module.exports = __webpack_public_path__ + "img/index_mall.489df329.png";